export function PageInfo({ info }) {
    return (
        <div className="overflow-hidden rounded-lg mb-2 text-zinc-400">
            <div className="px-4 py-5 sm:p-4 !pl-0">{info}</div>
        </div>
    )
}